import { BRACKET_DISPUTE_LIST_ACTION } from "core/constants/Actions";
import { Action } from "core/models/ActionTypes";
import { DisputedBracket } from "core/models/Bracket";
import { Space } from "core/models/Space";
import { Tournament } from "core/models/Tournament";

const initialState: {
  disputedBrackets: DisputedBracket[];
  isLoading: boolean;
  currentPage: number;
  count: number;
} = {
  disputedBrackets: [],
  isLoading: false,
  count: 0,
  currentPage: 0,
};

interface ActionType extends Action {
  payload: {
    disputedBrackets: DisputedBracket[];
    count: number;
    currentPage: number;
  };
}

export default function bracektDisputeReducer(
  state = initialState,
  action: ActionType
) {
  switch (action.type) {
    case BRACKET_DISPUTE_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true };

    case BRACKET_DISPUTE_LIST_ACTION.SUCCESS:
      const {  count, disputedBrackets, currentPage } = action.payload;
      return {
        ...state,
        count,
        disputedBrackets,
        currentPage,
        isLoading: false,
      };

    case BRACKET_DISPUTE_LIST_ACTION.FAILURE:
      return { ...state, ...initialState };

    default:
      return state;
  }
}
